/* eslint-disable no-return-assign */
import { useRef } from 'react';
import styled from 'styled-components';
import setImageSize from 'Utils/UtilityFunctions';
import {
  conscientiousBanner,
  dominantBanner,
  influencingBanner,
  maxMobile, primaryFont, steadyBanner, wBold,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  position: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  right: 0;
  bottom: 0;
  z-index: 100;
  height: 240px;
  width: 420px;
  @media all and (max-width: ${maxMobile}) {   
    height: 180px;
    width: 300px;
  }
  img {
    height: 100%;
    width: 100%;
  }
  .banner-heading {
    left: 37px;
    top: 48px;
    position: absolute;
    font-size: 25px;
    line-height: 30px;
    width: 250px;
    color: #fff;
    font-weight: 700;
    @media all and (max-width: ${maxMobile}){
    left: 25px;
    top: 35px;
    font-size: 18px;
    line-height: 24px;
    width: 185px; 
    }
  }
  .banner-wrapper{
    position: relative;
    .cross-circle-svg{
      cursor: pointer;
      position: absolute;
      right: 18px;
      top: -6px;
      @media all and (max-width: ${maxMobile}){
        height: 16px;
        width: 16px;
        right: 14px;
        top: -4px;
      }
    }
  }

`;

const Button = styled.span<{ color: string }>`
  font-size: 15px;
  line-height: 15px;
  display: inline-block;
  font-weight: ${wBold};
  font-family: ${primaryFont};
  color: ${props => props.color};
  background-color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 10px 15px;
  position: absolute;
  cursor: pointer;
  top: 185px;
  left: 36px;
  @media all and (max-width: ${maxMobile}) {
    font-size: 12px;
    padding: 7px 10px;
    top: 132px;
    left: 25px;
  }
`;
type Props = {
  personPersonality: string,
  loading: boolean,
  onCTAClick: () => void
  text: string,
};
const GuestBanner = function BookaDemo(props: Props) {
  const {
    personPersonality, loading, onCTAClick, text,
  } = props;
  const elementRef = useRef<HTMLDivElement>(null);

  const getBanner = (personality: string) => {
    if (personality === 'Dominant') {
      return dominantBanner;
    } if (personality === 'Conscientious') {
      return conscientiousBanner;
    } if (personality === 'Steady') {
      return steadyBanner;
    }
    return influencingBanner;
  };

  const getTextColor = (personality: string) => {
    if (personality === 'Dominant') {
      return '#F5222D';
    } if (personality === 'Conscientious') {
      return '#1890FF';
    } if (personality === 'Steady') {
      return '#52C41A';
    }
    return '#FAAD14';
  };

  return (
    <Wrapper ref={elementRef}>
      {loading ? null
        : (
          <div className="banner-wrapper">
            <img
              src={setImageSize(
                getBanner(personPersonality),
                elementRef.current?.clientWidth || 300,
                elementRef.current?.clientHeight || 180,
                0,
              )}
              alt="guestbanner"
              className="guestbanner"
            />
            <h3 className="banner-heading">{text}</h3>
            <Button
              color={getTextColor(personPersonality)}
              onClick={onCTAClick}
              onKeyPress={onCTAClick}
            >
              SCHEDULE A DEMO
            </Button>
          </div>
        )}
    </Wrapper>
  );
};

export default GuestBanner;
